import { AutogenModelVendor, AutogenRowVendor } from "./autogen/AutogenModelVendor";

export class ModelVendor extends AutogenModelVendor<RowVendor> {
	constructor() {
		super(RowVendor);
	}
}

export class RowVendor extends AutogenRowVendor {
}